import React, { Component } from 'react';

import Price from '../../../../shared/Price/Price';

import './ProdottoRiepilogo.scss';
import { ImageDispatcher } from '../../../../shared/ImageDispatcher/ImageDispatcher';

class ProdottoRiepilogo extends Component {

  renderSubtotal() {
    let { product } = this.props;

    return (
      product.price * product.quantity
    );
  }

  render() {
    let { product } = this.props;

    return (
      <tr className="prodotto-riepilogo">
        <td className="col-image">
          <ImageDispatcher src={product.image} alt={product.name} />
        </td>
        <td className="col-description">
          {product.name}
        </td>
        <td className="col-quantity">
          {product.quantity}
        </td>
        <td className="col-price text-right">
          <span className="prev-price"><Price amount={product.listPrice} /></span>
          <Price amount={product.price} />
        </td>
      </tr>
    );
  }
}

export default ProdottoRiepilogo;
